<template>
  <tk-container
    :status="status"
    @refresh="init"
    class=""
  >
    <!-- 返回 -->
    <tk-flex
      middle
      :gutter="10"
      slot="header"
      class="flex items-center px-15 pt-15 mb-10"
    >
      <div class="pb-3">
        <global-back />
      </div>
      <global-title class="flex-grow" :is-show-home="false" />
    </tk-flex>
    <div class="pb-15">
      <div class="h-8" />
      <div class="w-full px-0">
        <div class="px-15">
          <!-- 轮播图 -->
          <swipe-card
            :data="swipeList"
          />
          <!-- 基本信息 -->
          <div
            class="mb-5 mt-13 rounded-14 border-solid border-pink border bg-white p-15"
          >
            <div class="flex spacex-14">
              <div class="text-13 font-bold line-height-22 line-2">
                {{ courseData.title }}
              </div>
            </div>
            <div
              v-if="courseData.introduction"
              class="text-11 line-height-22 text-gray"
            >
              {{ courseData.introduction }}
            </div>
            <div class="mt-8 flex items-center justify-between">
              <!-- 金额 -->
              <div
                v-if="courseData.price"
                class="text-14 font-bold line-height-14 text-orange"
              >
                <span class="text-10">￥</span>{{ courseData.price }}
              </div>
              <div
                v-else
                class="text-14 font-bold line-height-14 text-orange"
              >
                免费
              </div>
              <tk-flex
                middle
                :gutter="3"
                class="flex items-center text-10 text-gray"
              >
                <div>
                  {{ period }}
                </div>
                <div v-if="courseData.price > 0 && this.isShowExchangeCount">
                  |
                </div>
                <div v-if="courseData.price > 0 && this.isShowExchangeCount">
                  {{ `${count}人兑换` }}
                </div>
              </tk-flex>
            </div>
          </div>
        </div>
        <!-- tab sticky -->
        <van-tabs
          v-model="active"
          swipeable
          color="#FC6554"
          :line-width="19"
          :line-height="4"
          class="bg-white"
        >
          <van-tab
            v-for="(item, index) in classifiList"
            :key="index"
            :title="item"
            class="px-15"
          >
            <!-- 详情 -->
            <div
              v-if="index === 0"
            >
              <div
                v-if="validate(courseData.details)"
                class="custom-html"
                @click="viewBigImg($event)"
                v-html="courseData.details"
              />
              <global-empty
                v-else
                word="暂无详情～"
                :top="34"
                :bottom="34"
              />
            </div>
            <!-- 目录 -->
            <div
              v-if="index === 1"
              class="pb-15"
            >
              <!-- 公开课不用判断 -->
              <div v-if="!courseData.price">
                <!-- 判断有没有登录 -->
                <global-empty
                  v-if="!sessionToken"
                  img="/img/mydd.png"
                  word="登录后查看完整目录内容～"
                  is-show-btn
                  :top="34"
                  :bottom="34"
                />
                <div v-else>
                  <catalogue-list
                    v-if="courseData.courseCatalog && courseData.courseCatalog.list.length"
                    :course-id="courseData.objectId"
                    :catalogue="courseData.courseCatalog"
                    :name="courseData.title"
                    :watchUrlRecord="watchUrlRecord"
                  />
                  <global-empty
                    v-else
                    img="/img/mydd.png"
                    word="暂无目录信息～"
                    :top="34"
                    :bottom="34"
                  />
                </div>
              </div>
              <!-- 非公开课 -->
              <div v-else>
                <!-- 判断有没有登录 -->
                <global-empty
                  v-if="!sessionToken"
                  img="/img/mydd.png"
                  word="登录后查看完整目录内容～"
                  is-show-btn
                  :top="34"
                  :bottom="34"
                />
                <!-- 未兑换 -->
                <global-empty
                  v-else-if="!isExchange"
                  img="/img/mydd.png"
                  word="兑换后查看完整目录内容～"
                  is-show-btn
                  btn-type="1"
                  :top="34"
                  :bottom="34"
                />
                <div v-else>
                  <catalogue-list
                    v-if="courseData.courseCatalog && courseData.courseCatalog.list.length"
                    :course-id="courseData.objectId"
                    :catalogue="courseData.courseCatalog"
                    :name="courseData.title"
                    :watchUrlRecord="watchUrlRecord"
                  />
                  <global-empty
                    v-else
                    img="/img/mydd.png"
                    word="暂无目录信息～"
                    :top="34"
                    :bottom="34"
                  />
                </div>
              </div>
            </div>
            <!-- 下载 -->
            <div
              v-if="index === 2"
              class="pb-15"
            >
              <!-- 公开课不用判断 -->
              <div v-if="!courseData.price">
                <!-- 判断有没有登录 -->
                <global-empty
                  v-if="!sessionToken"
                  img="/img/mydd.png"
                  word="登录后查看完整下载内容～"
                  is-show-btn
                  :top="34"
                  :bottom="34"
                />
                <div v-else>
                  <download-list
                    v-if="courseData.download && courseData.download.length"
                    :list="courseData.download"
                  />
                  <global-empty
                    v-else
                    img="/img/mydd.png"
                    word="暂无课程相关下载信息～"
                    :top="34"
                    :bottom="34"
                  />
                </div>
              </div>
              <!-- 非公开课 -->
              <div v-else>
                <!-- 判断有没有登录 -->
                <global-empty
                  v-if="!sessionToken"
                  img="/img/mydd.png"
                  word="登录后查看完整下载内容～"
                  is-show-btn
                  :top="34"
                  :bottom="34"
                />
                <!-- 未兑换 -->
                <global-empty
                  v-else-if="!isExchange"
                  img="/img/mydd.png"
                  word="兑换后查看完整下载内容～"
                  is-show-btn
                  btn-type="1"
                  :top="34"
                  :bottom="34"
                />
                <div v-else>
                  <download-list
                    v-if="courseData.download && courseData.download.length"
                    :list="courseData.download"
                  />
                  <global-empty
                    v-else
                    img="/img/mydd.png"
                    word="暂无课程相关下载信息～"
                    :top="34"
                    :bottom="34"
                  />
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { Toast, ImagePreview } from 'vant'
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      status: 'loading',
      id: this.$route.query.id,
      courseData: {
        courseCatalog: {
          type: false,
          list: []
        },
        showPicture: [],
        value: '',
        details: '',
        exchangeQuantity: 0
      },
      swipeList: [],
      bigImages: [],
      active: 0,
      classifiList: ['详情', '目录', '下载'],
      isExchange: false,
      exchangeCount: 0,
      watchUrlRecord: '',
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      sessionToken: state => state.sessionToken,
      isRecordProgress: state => state.isRecordProgress,
    }),
    ...mapGetters(['isShowExchangeCount']),
    count () {
      return this.courseData.exchangeQuantity || this.exchangeCount
    },
    period () {
      if (!this.courseData) {
        return `已更新 0 期`
      }
      if (!this.courseData.courseCatalog) {
        return `已更新 0 期`
      }
      if (!this.courseData.courseCatalog.list) {
        return `已更新 0 期`
      }
      if (!this.courseData.courseCatalog.list.length) {
        return `已更新 0 期`
      }
      if (this.courseData.courseCatalog.type) {
        return `已更新 ${this.courseData.courseCatalog.list.length} 章`
      }
      return `已更新 ${this.courseData.courseCatalog.list[0].list.length} 期`
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.exchangeStatus()
    if (!this.isRecordProgress) {
      return
    }
    this.catalogueSync()
    this.watchUrl()
  },
  methods: {
    // | 获取课程详情
    async init () {
      try {
        const { data: res } = await this.$tkParse.get(`/classes/courseList/${this.id}`).catch(async (e) => {
          Toast({
            message: '该课程不存在，即将返回',
            position: 'bottom',
          })
          await this.$tkHelper.sleep(1000)
          this.$back()
          throw e
        })
        res.courseCatalog = res.courseCatalog || {
          type: false,
          list: [ {
            title: '',
            list: []
          } ]
        }
        this.courseData = res
        this.swipeList = res.showPicture.map((s) => {
          return {
            showPictures: s,
          }
        })
        if (this.isRecordProgress) {
          await this.catalogueSync()
          await this.watchUrl()
        }
        this.htmlToImages(res)
        this.exchangeStatus()
        this.getExchangeCount()
        this.status = false
      } catch (e) {
        this.status = false
      }
    },
    // | 查看用户是否兑换该课程
    async exchangeStatus () {
      if (!this.sessionToken) { return }
      if (!this.courseData.price) { return }
      const res = await this.$tkParse.getList('/classes/exchangeRecord', {
        params: {
          limit: 1,
          where: {
            exchangeUser: this.user.objectId,
            course: this.id,
            status: '已使用',
          },
        },
      }).catch(() => {
        return Toast({
          message: '查询失败',
          position: 'bottom',
        })
      })
      if (res.length) { this.isExchange = true }
    },
    // 获取该课程兑换人次
    async getExchangeCount () {
      if (!this.id) { return }
      if (!this.isShowExchangeCount) { return }
      this.exchangeCount = await this.statisticsNum('exchangeRecord', {
        course: this.id,
        status: '已使用',
      })
    },
    // | 验证Htmlshi否为空
    validate (s) {
      if (!s) { return false }
      const reg = /<img.*?(?:>|\/>)/
      const videoReg = /<video.*?(?:>|\/>)/gi
      const images = s.match(reg)
      const videos = s.match(videoReg)
      if (!s.replace(/<[^>]+>/g, '') && !images && !videos) { return false }
      return true
    },
    // | 从详情中提取图片
    htmlToImages (item) {
      if (!item.details) { return }
      if (!this.validate(item.details)) { return }
      const imglist = []
      // 从b中提取网络图片地址整合成数组
      const reg = /<img.*?(?:>|\/>)/gi
      const arr = item.details.match(reg)
      // | 提取src
      if (arr) {
        for (let i = 0; i < arr.length; i++) {
          // eslint-disable-next-line no-useless-escape
          const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
          const src = arr[i].match(srcReg)
          if (src && src[1]) { imglist.push(src[1]) }
        }
      }
      this.bigImages = imglist
    },
    // | 点击查看大图
    viewBigImg (e) {
      if (this.bigImages.length === 0) { return }
      if (!e.target.currentSrc) { return }
      const index = this.bigImages.findIndex((s) => {
        return s === e.target.currentSrc
      })
      if (index === -1) { return }
      ImagePreview({
        images: this.bigImages,
        startPosition: index,
        closeable: true,
      })
    },
    // | 获取观看进度/观看次数
    async catalogueSync () {
      let list = (this.courseData.courseCatalog &&
       this.courseData.courseCatalog.list.length) ? this.courseData.courseCatalog.list : []
      if (!this.sessionToken) { return }
      if (!list) { return }
      if (!list.length) { return }
      for (let j = 0; j < list.length; j++) {
        let batchRequest1 = []
        let batchRequest2 = []
        let item = list[j]
        for (let i = 0; i < item.list.length; i++) {
          const request1 = this.$tkParse.getList('/classes/recordProgress', {
            params: {
              limit: 1,
              order: '-createdAt',
              where: {
                user: this.user.objectId,
                course: this.id,
                vcode: item.list[i].vcode,
              },
            },
          })
          // 学习次数
          const request2 = this.$tkParse.get('/classes/recordProgress', {
            params: {
              limit: 0,
              count: 1,
              where: {
                user: this.user.objectId,
                course: this.id,
                vcode: item.list[i].vcode,
              },
            },
          })
          batchRequest1.push(request1)
          batchRequest2.push(request2)
        }
        let result1 = await Promise.all(batchRequest1)
        let result2 = await Promise.all(batchRequest2)
        for (let i = 0; i < item.list.length; i++) {
          if (result1[i].length) { item.list[i].percent = result1[i][0].percentage || 0 } else { item.list[i].percent = 0 }
          if (result2[i].data) { item.list[i].count = result2[i].data.count }
        }
      }
      this.courseData.courseCatalog.list = list
    },
    // | 上次看到什么位置
    async watchUrl () {
      if (!this.sessionToken) { return }
      const res = await this.$tkParse.getList('/classes/recordProgress', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            user: this.user.objectId,
            course: this.id,
          },
        },
      }).catch(e => {
        throw e
      })
      if (res.length) { this.watchUrlRecord = res[0].vcode }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-tab:nth-child(1) {
    padding-left: 0;
  }
  .van-tabs__nav--complete {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
